import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { TransparentDatePicker } from "../../components/buttons/TransparentDatePicker";
import { SelectInput } from "../../components/inputs/Select";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Langs from "../../app/lang/langs";
import { addSubcontractor, getSubcontractors, setsubcontractors } from "../../components/clients/clientsSlice";
import { TextInput } from "../../components/inputs/TextInput";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { uploadAsset } from "../../assets/assetsSlice";
import { Calendar } from "primereact/calendar";
import moment from "moment";

export default function AddSubcontractorModal(props) {
    const dispatch = useDispatch();

    const typeOptions = useSelector((state) => state.clients.providerTypes)
    const isMobile = useSelector((state) => state.settings.isMobile)

    const [form, setForm] = useState({
        name: '',
        email: '',
        address: '',
        reminders_dates: '',
        reminders_comments: '',
        date_attestation_urssaf: null,
        date_fin_attestation_urssaf: null,
        date_attestation_fiscale: null,
        date_fin_attestation_fiscale: null,
        date_fin_validite_rc: null,
        date_fin_attestation_salarie_etranger: null,
        status: 'Actif',
        type: 'Indépendant',
    })

    const [inputStyle, setInputStyle] = useState(false);
    const [files, setFiles] = useState([]);

    const statusOptions = [
        { label: "Actif", value: "Actif" },
        { label: "Inactif", value: "Inactif" },
    ]

    const handleFieldChange = (field, e) => {
        setForm((prev) => ({ ...prev, [field]: e }));
    }

    const handleFileUpload = (e) => {
        setFiles(e.target.files);
    }

    const handleAddSubcontractor = () => {
        if (form.name.trim() === '' || form.email.trim() === '') {
            showErrorToast(`Les champs "nom" et "email" sont obligatoires`);
            setInputStyle(true);
            return;
        }
        let payload = { ...form };
        console.log(form)
        payload = {
            ...payload,
            date_attestation_urssaf: form.date_attestation_urssaf ? moment(form.date_attestation_urssaf).format('YYYY-MM-DD') : null,
            date_fin_attestation_urssaf: form.date_fin_attestation_urssaf ? moment(form.date_fin_attestation_urssaf).format('YYYY-MM-DD') : null,
            date_attestation_fiscale: form.date_attestation_fiscale ? moment(form.date_attestation_fiscale).format('YYYY-MM-DD') : null,
            date_fin_attestation_fiscale: form.date_fin_attestation_fiscale ? moment(form.date_fin_attestation_fiscale).format('YYYY-MM-DD') : null,
            date_fin_validite_rc: form.date_fin_validite_rc ? moment(form.date_fin_validite_rc).format('YYYY-MM-DD') : null,
            date_fin_attestation_salarie_etranger: form.date_fin_attestation_salarie_etranger ? moment(form.date_fin_attestation_salarie_etranger).format('YYYY-MM-DD') : null,
        };
        console.log(payload);
        dispatch(addSubcontractor({ subcontractor: payload }))
            .then((response) => {
                const responseData = response.payload.responseData;
                if (responseData && responseData.status === 1) {
                    const newSubcontractor = { ...form, id: responseData.insert_id, assets: [] };
                    if (files.length > 0) {
                        Array.from(files).forEach((file) => {
                            dispatch(uploadAsset({
                                tableName: 'subcontractors',
                                idParent: responseData.insert_id,
                                filename: file.name,
                                file,
                            }))
                        });
                    }
                    showSuccessToast('Subcontractor added successfully');
                    handleClose(true);
                }
            })
            .catch((error) => {
                showErrorToast("Error adding subcontractor");
                console.error("Error:", error);
            });
    };


    const handleClose = (check) => {
        props.onHide();
        setInputStyle(false);
        setForm({
            name: '',
            email: '',
            address: '',
            reminders_dates: '',
            reminders_comments: '',
            date_attestation_urssaf: null,
            date_fin_attestation_urssaf: null,
            date_attestation_fiscale: null,
            date_fin_attestation_fiscale: null,
            date_fin_validite_rc: null,
            date_fin_attestation_salarie_etranger: null,
            status: 'Actif',
            type: 'Indépendant',
        });
        setFiles([]);
        if (check) {
            dispatch(getSubcontractors())
        }
    };

    return (
        <Dialog
            visible={props.visible}
            style={{ width: isMobile == 2 ? "90%" : "60%" }}
            onHide={handleClose}
            header={<Langs str="ADD_SUBCONTRACTOR" />}
            draggable={false}
            dismissableMask={false}
        >
            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={2} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="Nom" /></label>
                </Col>
                <Col lg={4} className="mb-1 pe-3">
                    <TextInput
                        value={form.name}
                        onChange={(e) => handleFieldChange('name', e.target.value)}
                        className={inputStyle && !form.name ? 'p-invalid' : ''}
                    />
                </Col>
                <Col lg={2} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="EMAIL" /></label>
                </Col>
                <Col lg={4} className="mb-1 pe-3">
                    <TextInput
                        value={form.email}
                        onChange={(e) => handleFieldChange('email', e.target.value)}
                        className={inputStyle && !form.email ? 'p-invalid' : ''}
                    />
                </Col>
            </Row>
            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={2} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="ADDRESS" /></label>
                </Col>
                <Col lg={4} className="mb-1 pe-3">
                    <TextInput
                        value={form.address}
                        onChange={(e) => handleFieldChange('address', e.target.value)}
                    />
                </Col>
                <Col lg={2} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="REMINDERS_DATES" /></label>
                </Col>
                <Col lg={4} className="mb-1 pe-3">
                    <TextInput
                        value={form.reminders_dates}
                        onChange={(e) => handleFieldChange('reminders_dates', e.target.value)}
                    />
                </Col>
            </Row>
            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={2} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="STATUS" /></label>
                </Col>
                <Col lg={4} className="mb-1 pe-3">
                    <SelectInput
                        options={statusOptions}
                        value={form.status}
                        onChange={(e) => handleFieldChange('status', e.value)}
                    />
                </Col>
                <Col lg={2} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="TYPE" /></label>
                </Col>
                <Col lg={4} className="mb-1 pe-3">
                    <SelectInput
                        options={typeOptions}
                        value={form.type}
                        onChange={(e) => handleFieldChange('type', e.value)}
                    />
                </Col>
            </Row>
            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="DATE_ATTESTATION_URSSAF" /></label>
                </Col>
                <Col lg={3} className="mb-1 pe-3">
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={form.date_attestation_urssaf} style={{ width: '25rem' }} onChange={(e) => handleFieldChange('date_attestation_urssaf', e.target.value)} showButtonBar />
                </Col>
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="DATE_FIN_ATTESTATION_URSSAF" /></label>
                </Col>
                <Col lg={3} className="mb-1 pe-3">
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={form.date_fin_attestation_urssaf} style={{ width: '25rem' }} onChange={(e) => handleFieldChange('date_fin_attestation_urssaf', e.target.value)} showButtonBar />
                </Col>
            </Row>
            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="DATE_ATTESTATION_FISCALE" /></label>
                </Col>
                <Col lg={3} className="mb-1 pe-3">
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={form.date_attestation_fiscale} style={{ width: '25rem' }} onChange={(e) => handleFieldChange('date_attestation_fiscale', e.target.value)} showButtonBar />
                </Col>
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="DATE_FIN_ATTESTATION_FISCALE" /></label>
                </Col>
                <Col lg={3} className="mb-1 pe-3">
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={form.date_fin_attestation_fiscale} style={{ width: '25rem' }} onChange={(e) => handleFieldChange('date_fin_attestation_fiscale', e.target.value)} showButtonBar />
                </Col>
            </Row>
            <Row className="py-3 d-flex justify-content-space-between">
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="DATE_FIN_VALIDITE_RC" /></label>
                </Col>
                <Col lg={3} className="mb-1 pe-3">
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={form.date_fin_validite_rc} style={{ width: '25rem' }} onChange={(e) => handleFieldChange('date_fin_validite_rc', e.target.value)} showButtonBar />
                </Col>
                <Col lg={3} className="mb-1 d-flex align-items-center fw-bold">
                    <label className="fw-bold"><Langs str="DATE_FIN_ATTESTATION_SALARIE_ETRANGER" /></label>
                </Col>
                <Col lg={3} className="mb-1 pe-3">
                    <Calendar dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" value={form.date_fin_attestation_salarie_etranger} style={{ width: '25rem' }} onChange={(e) => handleFieldChange('date_fin_attestation_salarie_etranger', e.target.value)} showButtonBar />
                </Col>
            </Row>
            <Row className="py-3">
                <Col lg={3} className="fw-bold">
                    <label className="fw-bold"><Langs str="UPLOAD_FILES" /></label>
                </Col>
                <Col lg={9}>
                    <input
                        type="file"
                        multiple
                        onChange={handleFileUpload}
                        className="form-control"
                    />
                </Col>
            </Row>
            <Row className="pt-4 d-flex justify-content-space-between">
                <Col lg={9} className="d-flex justify-content-start"></Col>

                <Col lg={3} className="d-flex justify-content-between">
                    <PrimaryButton
                        onClick={handleAddSubcontractor}
                        className=""
                        title={<Langs str="ADD" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
        </Dialog>
    );

}
